/* The module specifier is the cache key: three callers importing this with
   three different ?v= values meant three separate downloads of the same 27KB
   file. Every importer now uses the same string. */
import {generateProductHtml} from "./ob-generate-product-html.js?v=14233445439"

document.addEventListener("DOMContentLoaded", () => {
    const equivelant100 = parseFloat(document.getElementById("100-money").value);
    const currencySymbol = document.body.getAttribute("currency-symbol")
    const is_sale = document.body.dataset.sale == "true";
  const nostoContainers = document.querySelectorAll(".nosto-product-recommendation-ob-slider");
  const market = document.body.getAttribute("market") === 'eu' ? 'eu' : 'uk';
const marketTag = `country-${market}`;
var currentDate = new Date();
var currentMonth = currentDate.toLocaleString('en-US', {
        month: 'short'
    }).toLowerCase();

    const countryIso = document.body.getAttribute("country-iso");

  if (nostoContainers.length === 0) return;

  const populateContainer = async (container) => {
    const prodWrappers = container.querySelectorAll(".nosto-controlled-carousel-card");
    const prodCount = prodWrappers.length;
    const collId = container.dataset.collectionId;

    if (!prodCount || !collId) return;

    nostojs(async (api) => {
      const res = await api.search({
           products: {
                    fields: ["name", "price", "listPrice", "imageUrl", "url", "available", "tags1", "categories", "alternateImageUrls", "skus.id", "skus.name", "skus.availability", "skus.customFields.key", "skus.customFields.value", "customFields.key", "customFields.value"],
                    size: prodCount,
                    categoryId: collId,
                    facets: ['*'],
                    from: 0
                },
        keywords: {
          fields: ["keyword"]
        }
      });
      const prods = res.products.hits;
          var currentDate = new Date();
    var currentMonth = currentDate.toLocaleString('en-US', {
        month: 'short'
    }).toLowerCase();
      prods.forEach((prod, index)=>{
        try{

            const prodHTML = generateProductHtml({product:prod, index, homePageWrapper:true});
            prodWrappers[index].innerHTML = "";
            if(prodHTML){
                prodWrappers[index].appendChild(prodHTML);
            }else{
                prodWrappers.style.display="none";
            }
        }catch(error){
            console.error("error adding product: " + prod.name + error.message)
            prodWrappers[index].remove();
        }
      })
      let currency = document.body.getAttribute("currency");
    if (currency !== 'AAAAA') {
        const updatePromises = prods.map(product => updateNonUKPrices(product.productId, currency));
        await Promise.all(updatePromises);
    }
      const stillLoading = container.querySelectorAll(".nosto-controlled-carousel-card:has(.loading-prod)")
      stillLoading.forEach((loader)=>{
        loader.remove();
      })
      if(labelList){
        addLabels()
    }else{
        const labelCheck = setInterval(()=>{
            if(labelList){
                addLabels()
                clearInterval(labelCheck)
            }
        },100)
        setTimeout(()=>{
            clearInterval(labelCheck)
        },10000)
    }
      return
    });
  };

function addLabels(count = 0) {
    let newcount = count + 1;
    if(newcount > 20) return;
    const products = document.querySelectorAll('.product-card');
    if (labelList) {
        products.forEach(function(card) {
            try {
                // Find the input element with class 'prod-info' within the current card
                let prodInfo = card.querySelector('.prod-info');
                let prod = JSON.parse(prodInfo.value); // Use the value of the input element
                let label = generateProductLabel(prod);
                if(card.classList.contains("flash-sale-product")){
                    const progBar = card.querySelector(".sale-progress-bar");
                    const funkyBg = progBar?.style.background;
                    label = `<span class="flash-sale-label flex items-center absolute top-2 right-2 rounded font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12;
                     background: ${progBar? funkyBg : "#f00"};
                      color:#fff; border: 2px solid #F00${progBar && "0"}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">
                    <div style="background:black; padding: 0.25rem; border-radius: 0.305rem; display: flex; align-items: center;">
<svg height="20px" width="20px" style="stroke: white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="#fff" x="0px" y="0px"><path d="M4.03196 18.98H6.77929C7.71819 16.6885 8.86513 14.4879 10.2057 12.4058C10.8009 11.5816 11.3945 10.8033 11.9864 10.0709C10.6318 10.189 9.31106 10.5582 8.09154 11.1595C6.85362 11.8141 5.8199 12.797 5.10379 14.0003C4.38768 15.2037 4.01684 16.5811 4.03196 17.9814V18.98Z" fill="black"/><path d="M13.02 25.2207C15.3116 24.2802 17.5123 23.1316 19.5942 21.7893C20.4218 21.1947 21.2001 20.6029 21.9291 20.0137C21.811 21.3682 21.4418 22.6889 20.8405 23.9085C20.1859 25.1464 19.203 26.1801 17.9997 26.8962C16.7963 27.6123 15.4189 27.9832 14.0186 27.968H13.02V25.2207Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28 7C27.8613 11.3428 24.7311 15.65 18.4308 20.1694C16.7146 21.282 14.904 22.2417 13.02 23.0376V22.4754C13.0155 21.5497 12.6458 20.6633 11.9913 20.0087C11.3367 19.3542 10.4503 18.9845 9.52463 18.98H8.96238C9.75922 17.096 10.7203 15.2858 11.8346 13.5702C16.3475 7.27364 20.6518 4.14381 24.992 4C24.9947 4 24.9973 4 25 4H28V7ZM21.2767 10.7233C21.7449 11.1915 22.008 11.8265 22.008 12.4887C22.008 13.1508 21.7449 13.7859 21.2767 14.2541C20.8085 14.7223 20.1735 14.9854 19.5113 14.9854C18.8492 14.9854 18.2141 14.7223 17.7459 14.2541C17.2777 13.7859 17.0146 13.1508 17.0146 12.4887C17.0146 11.8265 17.2777 11.1915 17.7459 10.7233C18.2141 10.2551 18.8492 9.99201 19.5113 9.99201C20.1735 9.99201 20.8085 10.2551 21.2767 10.7233Z" fill="black"/><path d="M10.1458 26.0915C9.24001 26.9963 6.52863 27.5536 5.40413 27.7533L4 28L4.24667 26.5959C4.44541 25.4714 5.00366 22.76 5.90846 21.8542C6.47036 21.2923 7.23247 20.9766 8.02713 20.9766C8.42061 20.9766 8.81023 21.0541 9.17375 21.2047C9.53727 21.3553 9.86758 21.576 10.1458 21.8542C10.424 22.1324 10.6447 22.4627 10.7953 22.8263C10.9459 23.1898 11.0234 23.5794 11.0234 23.9729C11.0234 24.3663 10.9459 24.756 10.7953 25.1195C10.6447 25.483 10.424 25.8133 10.1458 26.0915Z" fill="black"/></svg>                    Launch Offer
                    </div>
                    </span>
`
                }

                // Find the element with class 'label-loc' within the current card
                let labelLoc = card.querySelector('.label-loc');
                labelLoc.innerHTML = label; // Set the innerHTML to the generated label
            } catch (error) {
                console.error("Error adding label: " + error);
            }
        });
    } else {
        setTimeout(function() {
            addLabels(newcount);
        }, 300)
    }


}

  const useNosto = async () => {
    for(let i = 0; i < nostoContainers.length; i++){

        await populateContainer(nostoContainers[i]);
    }
    
  };

  const nostoCheck = setInterval(() => {
    if (typeof window.Nosto !== "undefined") {
      clearInterval(nostoCheck);
      useNosto();
    }
  }, 100);

const populateFlashSaleList = async (flashSaleWrapper, product, wrapper) => {
    const priceDiv = wrapper.querySelector(".product-card__details__price");
    try{
        
        flashSaleWrapper.className = "animate-mt flash-sale-collection-wrapper"
        let url = `${product.url}?view=get-flash-sale-list`
        const metaObject = await fetch(url);
        const a = await metaObject.text();
        const metaObjectValue = JSON.parse(a); 
        let saleFound = false
        
        metaObjectValue.forEach((sale)=>{
            if(saleFound) return;
            const { sale_number, remaining_sale, sale_type, sale_value, background_colors } = sale;
            const label  = wrapper.closest(".product-card").querySelector(".flash-sale-label");
            const backgroundColor = background_colors? `linear-gradient(to right, ${background_colors[0]} 0%, ${background_colors[1]} 33%, ${background_colors[2]} 66%, ${background_colors[3]} 100%)` : "#f00"
            if(label){
                label.style.border = "2px solid transparent";
                label.style.background = `
                    linear-gradient(#fff, #fff) padding-box,${backgroundColor}`
            }
            const endDate = new Date(sale.end_date);
            const timeToEnd = endDate - Date.now();
            const startDate = new Date(sale.start_date)
            let timeToStart = startDate - Date.now(); 
            if (timeToEnd <= 0 || remaining_sale < 1 || timeToStart > 0 ) {
                return
            }
            saleFound = true

            const timerWrapper = document.createElement("div");
            timerWrapper.className="timer-wrapper"
            const timerSvg = `<svg style="height:12px; color:${background_colors[0]}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12.5523 6 13 6.44772 13 7V10.9296C13 11.2099 13.001 11.3523 13.0105 11.4539L13.011 11.459L13.0149 11.4622C13.0942 11.5264 13.2121 11.6062 13.4453 11.7617L15.5547 13.1679C16.0142 13.4743 16.1384 14.0952 15.8321 14.5547C15.5257 15.0142 14.9048 15.1384 14.4453 14.8321L12.3359 13.4258C12.3267 13.4197 12.3176 13.4136 12.3084 13.4075C12.1143 13.2781 11.9165 13.1463 11.7558 13.0161C11.5714 12.8667 11.3804 12.6771 11.2367 12.4085C11.0929 12.14 11.0411 11.8758 11.0191 11.6396C10.9999 11.4336 11 11.1959 11 10.9627V7C11 6.44772 11.4477 6 12 6Z" fill="black"/>
</svg>`
    timerWrapper.innerHTML += timerSvg
    
    const timerDiv = document.createElement("div");
    timerDiv.className="flash-sale-timer"
    timerDiv.style.background = background_colors[0];
    timerDiv.style.webkitBackgroundClip = "text";
    timerDiv.style.backgroundClip = "text";
    timerDiv.style.webkitTextFillColor = "transparent";
    const separator = document.createElement("div");
    separator.innerHTML = "|";
    separator.className = "flash-sale-seperator"
    timerWrapper.append(timerDiv);
    
    flashSaleWrapper.append(timerWrapper, separator);
    
    
    const daysEle = document.createElement("div");
    daysEle.className = "timer-unit timer-days"
    const daysSep = document.createElement("div");
    const hoursSep = document.createElement("div");
    const minutesSep = document.createElement("div");
    
    const hoursEle = document.createElement("div");
    hoursEle.className = "timer-unit timer-hours"
    const minutesEle = document.createElement("div");
    minutesEle.className = "timer-unit timer-minutes"
    const secondsEle = document.createElement("div");
    secondsEle.className = "timer-unit timer-seconds"
    
    daysSep.innerHTML = ":";
    hoursSep.innerHTML = ":";
    minutesSep.innerHTML = ":";
    
    timerDiv.append(daysEle,daysSep,hoursEle,hoursSep,minutesEle,minutesSep,secondsEle);
    
    
    const totalSeconds = Math.floor(timeToEnd / 1000);
    
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;
    const pad = (num) => String(num).padStart(2, "0");
    
    
    daysEle.innerHTML = pad(days);
    hoursEle.innerHTML = pad(hours);
    minutesEle.innerHTML = pad(minutes);
    secondsEle.innerHTML = pad(seconds);
    
    
    const timerInterval = setInterval(()=>{
        const timeToEnd = endDate - Date.now();
        
        if (timeToEnd <= 0) {
            flashSaleWrapper.remove();
            clearInterval(timerInterval);
            return
        }
        
        const totalSeconds = Math.floor(timeToEnd / 1000);
        
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        
        
        daysEle.innerHTML = pad(days);
        hoursEle.innerHTML = pad(hours);
        minutesEle.innerHTML = pad(minutes);
        secondsEle.innerHTML = pad(seconds);
    }, 1000)
    
    const complete = 100 - Math.round(((sale_number - remaining_sale)/sale_number)*100);
    let saleProgress = document.createElement("div");
    saleProgress.className = "sale-progress-wrapper";
    const saleProgressBarContainer = document.createElement("div");
    saleProgressBarContainer.className = "sale-progress-bar-container"
    saleProgressBarContainer.style.height = "7px";
    const saleProgressText = document.createElement("div");
    saleProgressText.innerHTML = `${complete}% remaining`
    const saleProgressBar = document.createElement("div");
    saleProgressBar.className  = "sale-progress-bar";
    saleProgressBar.style.background = backgroundColor;
    saleProgressBarContainer.append(saleProgressBar);
    saleProgressBar.style.width = `${complete}%`;
    saleProgress.append(saleProgressText, saleProgressBarContainer)
    flashSaleWrapper.append(saleProgress);
    flashSaleWrapper.classList.remove("animate-mt")
    
    let newPrice = sale_type == "percent" ? product.listPrice * (1-sale_value/100) : product.listPrice - sale_value;
    if(priceDiv){
        const newPriceFormatted = formatMoney(Math.round(newPrice * 100), GEBO.settings.shop_money_format);
        const listPriceFormatted = formatMoney(Math.round(product.listPrice * 100), GEBO.settings.shop_money_format);
        priceDiv.innerHTML = newPriceFormatted + `<del class="ml-1 text-gray-400">${listPriceFormatted}</del>`
        priceDiv.classList.remove("animate-mt")
    }
})

if(!saleFound){
    wrapper.closest(".product-card").classList.remove("flash-sale-product")
        wrapper.closest(".product-card").querySelector(".label-loc").remove();
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
}
    }catch(error){
        console.error("error:" + error.message);
        console.error("removing flash sale")
        wrapper.closest(".product-card").classList.remove("flash-sale-product")
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
        return
    }
}
const populateFlashSale = async (flashSaleWrapper, product, wrapper) => {
    const priceDiv = wrapper.querySelector(".product-card__details__price");
    try{
        
        flashSaleWrapper.className = "animate-mt flash-sale-collection-wrapper"
        let url = `${product.url}?view=get-flash-sale`
        const metaObject = await fetch(url);
        const a = await metaObject.text();
        const metaObjectValue = JSON.parse(a); 
        const timerWrapper = document.createElement("div");
        timerWrapper.className="timer-wrapper"
        const timerSvg = `<svg style="height:12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" fill="black"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12.5523 6 13 6.44772 13 7V10.9296C13 11.2099 13.001 11.3523 13.0105 11.4539L13.011 11.459L13.0149 11.4622C13.0942 11.5264 13.2121 11.6062 13.4453 11.7617L15.5547 13.1679C16.0142 13.4743 16.1384 14.0952 15.8321 14.5547C15.5257 15.0142 14.9048 15.1384 14.4453 14.8321L12.3359 13.4258C12.3267 13.4197 12.3176 13.4136 12.3084 13.4075C12.1143 13.2781 11.9165 13.1463 11.7558 13.0161C11.5714 12.8667 11.3804 12.6771 11.2367 12.4085C11.0929 12.14 11.0411 11.8758 11.0191 11.6396C10.9999 11.4336 11 11.1959 11 10.9627V7C11 6.44772 11.4477 6 12 6Z" fill="black"/>
</svg>`
    timerWrapper.innerHTML += timerSvg
    
    const timerDiv = document.createElement("div");
    timerDiv.className="flash-sale-timer"
    const separator = document.createElement("div");
    separator.innerHTML = "|";
    separator.className = "flash-sale-seperator"
    timerWrapper.append(timerDiv);
    
    flashSaleWrapper.append(timerWrapper, separator);
    
    
    const daysEle = document.createElement("div");
    daysEle.className = "timer-unit timer-days"
    const daysSep = document.createElement("div");
    const hoursSep = document.createElement("div");
    const minutesSep = document.createElement("div");
    
    const hoursEle = document.createElement("div");
    hoursEle.className = "timer-unit timer-hours"
    const minutesEle = document.createElement("div");
    minutesEle.className = "timer-unit timer-minutes"
    const secondsEle = document.createElement("div");
    secondsEle.className = "timer-unit timer-seconds"
    
    daysSep.innerHTML = ":";
    hoursSep.innerHTML = ":";
    minutesSep.innerHTML = ":";
    
    timerDiv.append(daysEle,daysSep,hoursEle,hoursSep,minutesEle,minutesSep,secondsEle);
    
    const endDate = new Date(metaObjectValue.end_date);
    const timeToEnd = endDate - Date.now();
    
    
    const { sale_number, remaining_sale, sale_type, sale_value, active } = metaObjectValue;
    if (timeToEnd <= 0 || remaining_sale < 1 || !active) {
        wrapper.closest(".product-card").classList.remove("flash-sale-product")
        wrapper.closest(".product-card").querySelector(".label-loc").remove();
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
        return
    }
    
    const totalSeconds = Math.floor(timeToEnd / 1000);
    
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;
    const pad = (num) => String(num).padStart(2, "0");
    
    
    daysEle.innerHTML = pad(days);
    hoursEle.innerHTML = pad(hours);
    minutesEle.innerHTML = pad(minutes);
    secondsEle.innerHTML = pad(seconds);
    
    
    const timerInterval = setInterval(()=>{
                
        const endDate = new Date(metaObjectValue.end_date);
        const timeToEnd = endDate - Date.now();
        
        if (timeToEnd <= 0) {
            flashSaleWrapper.remove();
            clearInterval(timerInterval);
            return
        }
        
        const totalSeconds = Math.floor(timeToEnd / 1000);
        
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        
        
        daysEle.innerHTML = pad(days);
        hoursEle.innerHTML = pad(hours);
        minutesEle.innerHTML = pad(minutes);
        secondsEle.innerHTML = pad(seconds);
    }, 1000)

    const complete = Math.round(((sale_number - remaining_sale)/sale_number)*100);
    let saleProgress = document.createElement("div");
    saleProgress.className = "sale-progress-wrapper";
    const saleProgressBarContainer = document.createElement("div");
    saleProgressBarContainer.className = "sale-progress-bar-container"
    const saleProgressText = document.createElement("div");
    saleProgressText.innerHTML = `${complete}% claimed`
    const saleProgressBar = document.createElement("div");
    saleProgressBar.className  = "sale-progress-bar";
    saleProgressBarContainer.append(saleProgressBar);
    saleProgressBar.style.width = `${complete}%`;
    saleProgress.append(saleProgressText, saleProgressBarContainer)
    flashSaleWrapper.append(saleProgress);
    flashSaleWrapper.classList.remove("animate-mt")
    
    let newPrice = sale_type == "percent" ? product.listPrice * (1-sale_value/100) : product.listPrice - sale_value;
    if(priceDiv){
        const newPriceFormatted = formatMoney(Math.round(newPrice * 100), GEBO.settings.shop_money_format);
        const listPriceFormatted = formatMoney(Math.round(product.listPrice * 100), GEBO.settings.shop_money_format);
        priceDiv.innerHTML = newPriceFormatted + `<del class="ml-1 text-gray-400">${listPriceFormatted}</del>`
        priceDiv.classList.remove("animate-mt")
        }
    }catch(error){
        console.error("error:" + error.message);
        console.error("removing flash sale")
        wrapper.closest(".product-card").classList.remove("flash-sale-product")
        flashSaleWrapper.remove();
        priceDiv.classList.remove("animate-mt")
        return
    }
}

const createFlashSaleProdList = (product,  wrapper) => {
    const flashSaleWrapper = document.createElement("div");

    populateFlashSaleList(flashSaleWrapper, product, wrapper)
    return(flashSaleWrapper)
}
const createFlashSaleProd = (product,  wrapper) => {
    const flashSaleWrapper = document.createElement("div");

    populateFlashSale(flashSaleWrapper, product, wrapper)
    return(flashSaleWrapper)
}

// const generateProductHtml = (product, index, currentMonth, searchPage, target) => {
//     try {
//         product.price = (product.price) / 100 * equivelant100;
//         if (is_sale) {
//             const saleTag = product.tags1.find((tag) => {
//                 return tag.includes("lw-")
//             })
//             let saleAmount = Number(saleTag?.split("-").pop()) || 0;

//             product.price = product.price * (1 - (saleAmount / 100));
//         }
//         const flashSaleObj = product.customFields.find((field)=>{
//             return field.key == "custom-flash_sale"
//         })?.value
//         const flashSaleListObj = product.customFields.find((field)=>{
//             return field.key == "custom-flash_sale_list"
//         })?.value
//         product.listPrice = (product.listPrice) / 100 * equivelant100
//         let proceed = product.available || product.tags1.includes("show-out-of-stock-sold-out") || product.tags1.includes("sock-option-bundle");
//         const collectionHandle = document.getElementById("coll-handle")?.value;
//         const showInCollectionTag = product.tags1.find((tag)=>{
//             return tag.includes("show-in-collection-")
//         })
//         const toShowInCollection = product.tags1.some((tag)=>{
//             return tag == "show-in-collection"
//         })
//         const showInCollection = toShowInCollection? showInCollectionTag.includes(collectionHandle) : false;   
//         let hideMeProceed = !product.tags1.includes("hide-me") || (showInCollection && !searchPage)  //1234
//         proceed = proceed && hideMeProceed &&
//             (product.tags1.includes(marketTag) || !product.tags1.some(tag => tag.startsWith("country-")));
//         let tagsProceed = hideMeProceed &&
//             (product.tags1.includes(marketTag) || !product.tags1.some(tag => tag.startsWith("country-")));

//         if (product.alternateImageUrls) {
//             product.alternateImageUrls.unshift(product.imageUrl);
//         }
//         const tempProdImages = product.alternateImageUrls ? product.alternateImageUrls : [product.imageUrl];

//         let prodImages = tempProdImages.filter((url) => {
//             let toReturn = true;
//             let matchString = ("month-" + currentMonth);
//             toReturn = url.toLowerCase().includes("month-") ? url.toLowerCase().includes(matchString) : true;
//             toReturn = toReturn && (url.toLowerCase().includes("sub-") ? url.toLowerCase().includes("sub-collection") : true);
//             return toReturn;
//         });
//         if (!product.name.toLowerCase().includes('mid-collection') && !product.name.toLowerCase().includes('mid collection') && proceed) {
//             const productCard = document.createElement('div');
//             // Add unique identifier using product ID
//             productCard.setAttribute('data-product-id', product.productId);
//             productCard.classList.add("product-card", "flex", "flex-col");
//             if(flashSaleObj || flashSaleListObj){
//                 productCard.classList.add("flash-sale-product")
//             }
//             let tags = product.tags1;
//             if (tags.includes("design-cookie-monster") && false) {
//                 productCard.classList.add("cookie-monster-product")
//             }
//             //card_index+=;
//             const imageWrapper = document.createElement('div');
//             imageWrapper.classList.add("product-card__image-wrapper");
//             // const isPrepaid = product.name.toLowerCase().includes("prepaid");
//             // if(isPrepaid){
//             //     const match = product.name.toLowerCase().match(/\b\d{1,2}\s+months?\s+prepaid\b/i);
//             //     const result = match ? match[0] : null;
//             //     const roundel = document.createElement("div");
//             //     roundel.className = "absolute bottom-0 left-0 flex items-center justify-center text-xs p-2 font-bold prepaid-roundel text-center capitalize";
//             //     roundel.style.background="#000";
//             //     roundel.style.color = "#f00f83";
//             //     roundel.style.borderRadius = "0 0.305rem 0 0";
//             //     roundel.style.zIndex = "1";
//             //     roundel.style.maxWidth = "40%";
//             //     roundel.innerHTML = result;
//             //     imageWrapper.appendChild(roundel);
//             // }
//             const isSuperbowl = product.tags1.includes("super-bowl-60");
//             if(isSuperbowl){
//                 const roundel = document.createElement("div");
//                 roundel.className = "absolute bottom-0 left-0 text-white flex items-center justify-center text-xs p-2 font-bold prepaid-roundel text-center capitalize";
//                 roundel.style.background="#c6cacc";
//                 roundel.style.borderRadius = "0 0.305rem 0 0";
//                 roundel.style.zIndex = "1";
//                 roundel.style.maxWidth = "40%";
//                 roundel.innerHTML = "Super Bowl LX";
//                 imageWrapper.appendChild(roundel);
//             }
            

//             const prodContainer = document.createElement("div");
//             prodContainer.className = "prod-container";
//             const paddingEle = document.createElement("div");
//             paddingEle.className = "image-placeholder bg-gray-100"
//             const productLink = document.createElement('a');
//             productLink.id = "collection-product-link-" + (index + 1)
//             productLink.draggable = false;
//             let linkToUse = product.url.replace("https://www.myoddballs.com", "");
//             if(countryIso != "GB"){
//                 linkToUse = linkToUse.includes("?") ? linkToUse + `&country=${countryIso}` : linkToUse + `?country=${countryIso}`;
//             }
//             productLink.href = linkToUse;
//             productLink.classList.add("product-image-outer-wrapper");
            
            

            
//             let imagesToUse = prodImages.slice(0,2);
//             let loading = index > 3  ? "loading" : "";

//             imagesToUse.forEach((image, index)=>{
//                 const imgWrapper = document.createElement("div");
//                 imgWrapper.className = "grid-image-wrapper"
//                 const imgEle = document.createElement("img")
//                 imgEle.draggable = false;
//                 imgEle.loading = index == 0 && loading == "" ? "" : "lazy";
//                 imgEle.src = image 
//                 imgEle.srcset = modifyUrlWithResolutions(image);
//                 imgWrapper.append(imgEle);
//                 productLink.append(imgWrapper)
//             })

//             let desktopDotsWrapper = document.createElement("div");
//             desktopDotsWrapper.className = "desktop-dots-wrapper"
//             for(let i =0; i<imagesToUse.length; i++) {
//                 let dot = document.createElement("div");
//                 dot.className = "grid-swiper-dot";
//                 let dotOuter = document.createElement("div");
//                 dotOuter.className = "dot-outer"
//                 if(i == 0){
//                     dot.classList.add("active")
//                 }
//                 dot.dataset.index = i;
//                 dot.append(dotOuter);
//                 desktopDotsWrapper.append(dot);
//             }
//             prodContainer.append(desktopDotsWrapper);

//             prodContainer.append(paddingEle, productLink)
//             imageWrapper.appendChild(prodContainer);

//             const labelLoc = document.createElement('div');
//             labelLoc.className = "label-loc";
//             labelLoc.classList.add("text-xxs");
//             productCard.appendChild(imageWrapper);
//             productCard.appendChild(labelLoc);

//             // Quick add button
//             const quickAddWrapper = document.createElement('div');
//             quickAddWrapper.className = "bg-gray-100 justify-center p-3";
//             const quickAddDiv = document.createElement('div');
//             const bisSignup = document.createElement('div');
//             bisSignup.className = "rounded-full border border-black border-solid flex justify-center items-center text-center w-full bg-white sm:max-w-[90%] mx-auto py-2 text-xxs md:text-xs klaviyo-bis-trigger uppercase";
//             bisSignup.innerHTML = "Sign up to back in stock"
//             if (product.available || product.tags1.includes("sock-option-bundle")) {
//                 quickAddWrapper.append(quickAddDiv);
//             } else {
//                 quickAddWrapper.append(bisSignup);
//             }
//             quickAddDiv.className = "rounded-full border border-black border-solid grid grid-cols-2 w-full bg-white sm:max-w-[90%] mx-auto";

//             let gridType = (searchPage) ? "search-page-" : "collection-";

//             const seeMoreDiv = document.createElement('a');
//             seeMoreDiv.id = gridType + "see-more-" + (index + 1)
//             seeMoreDiv.href = linkToUse;
//             seeMoreDiv.className = "text-xxs md:text-xs items-center text-center uppercase border-r border-solid border-gray-300 py-2 md:py-2 font-semibold md:font-normal";
//             seeMoreDiv.innerText = translations.collections.see_more;
//             quickAddDiv.append(seeMoreDiv);

//             const quickAddLoader = document.createElement('div');
//             quickAddLoader.className = "w-4 quick-buy-loader";
//             quickAddLoader.innerHTML = GEBO.helpers.loader;

//             const quickAddButton = document.createElement('div');
//             quickAddButton.id = "home-page-carousel-quick-add-" + (index + 1)
//             quickAddButton.className = "event-quickbuy-show quick-add-wrapper text-xxs md:text-xs items-center text-center uppercase search-quick-add py-2 font-semibold md:font-normal relative md:py-2 flex justify-center";
//             quickAddButton.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
//             const quickBuyDiv = document.createElement('div');
//             quickBuyDiv.className = "quick-buy-text";
//             quickBuyDiv.innerHTML = translations.collections.quick_buy;
//             quickBuyDiv.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
//             quickAddButton.append(quickBuyDiv);

//             // Create padding div and append it correctly
//             const qbPadding = document.createElement('div');
//             qbPadding.className = "absolute left-0 coll-quick-add z-2";
//             qbPadding.style.top = "-50%";
//             qbPadding.style.width = "120%";
//             qbPadding.style.height = "195%";
//             qbPadding.setAttribute('data-handle', getShopifyProductHandle(product.url));
//             qbPadding.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
//             quickAddButton.append(qbPadding);
//             quickAddButton.append(quickAddLoader);
//             quickAddDiv.append(quickAddButton);

//             // Product details
//             const productDetails = document.createElement('div');
//             productDetails.append(quickAddWrapper);
//             productDetails.classList.add("product-card__details", "sm:px-0", "h-full", "pb-2");

//             const productTitleLink = document.createElement('a');
//             productTitleLink.id = "collection-product-title-" + (index + 1)
//             productTitleLink.classList.add("h-full", "flex", "flex-col", "justify-between");
//             productTitleLink.href = linkToUse;

//             let titleInfo = titleLogic(product);

//             const productTitle = document.createElement('p');
//             productTitle.classList.add("product-card__details__title", "px-2", "font-semibold", "flex");
//             // const titleEleWithHeart = document.createElement("div")
//             // titleEleWithHeart.textContent = String(titleInfo['cleanTitle']);
//             // titleEleWithHeart.style.width="0px";
//             // titleEleWithHeart.style.flexGrow="1";

//             // const heartSvgEleWrapper = document.createElement("div");
//             // heartSvgEleWrapper.classList.add("wishlist-wrapper")
//             // heartSvgEleWrapper.style.height="40px";
//             // heartSvgEleWrapper.style.width="50px";
//             // heartSvgEleWrapper.style.position="relative";
//             // const heartSvgEle = document.createElement("div");
//             // heartSvgEleWrapper.appendChild(heartSvgEle)
//             // heartSvgEle.className = "collection-wishlist-trigger w-full h-full";
//             // heartSvgEle.dataset.id = product.productId
//             // heartSvgEle.innerHTML = heartSvg;
//             // productTitle.append(titleEleWithHeart, heartSvgEleWrapper);

//             // (Dean) Adding Normal Title Back into the Dom
//             productTitle.textContent = String(titleInfo['cleanTitle'] || "");

//             const productTitleWrap = document.createElement('div');

//             const productCategory = document.createElement('p');
//             productCategory.classList.add("product-card__details__color", "px-2");
//             productCategory.textContent = String(titleInfo['subTitle']);

            
//             const productPrice = document.createElement('p');
//             if(flashSaleObj || flashSaleListObj){
//                 productPrice.classList.add("animate-mt")
//             }
//             productPrice.classList.add("product-card__details__price", "px-2", "text-magenta-500", "text-md");
//             const normalPrice = formatMoney(Math.round(product.price * 100), GEBO.settings.shop_money_format);
//             const listPriceFormatted = formatMoney(Math.round(product.listPrice * 100), GEBO.settings.shop_money_format);
//             const listPriceElement = product.listPrice > product.price ?
//                 `<del class="ml-1 text-gray-400">${listPriceFormatted}</del>` :
//                 `<del class="ml-1 text-gray-400 hidden">${listPriceFormatted}</del>`;
//             productPrice.innerHTML = `${normalPrice}${listPriceElement}`;

//             const productPriceWrap = document.createElement('div');

//             productTitleWrap.append(productTitle, productCategory);
//             productPriceWrap.append(productPrice);
//             productTitleLink.append(productTitleWrap, productPriceWrap);
//             if(flashSaleListObj){

//                 const flashSaleEl = createFlashSaleProdList(product, productTitleLink)
//                 productTitleLink.insertBefore(flashSaleEl, productPriceWrap);
//             }
//             else if(flashSaleObj){
//                  const flashSaleEl = createFlashSaleProd(product, productTitleLink)
//                  productTitleLink.insertBefore(flashSaleEl, productPriceWrap);
//             }

//             productDetails.appendChild(productTitleLink);
//             productCard.appendChild(productDetails);

//             const prodInfo = document.createElement('input');
//             prodInfo.setAttribute("type", "hidden");
//             prodInfo.setAttribute("value", JSON.stringify(product));
//             prodInfo.classList.add("prod-info");
//             productCard.appendChild(prodInfo);
//             //christmas message
//             const christmas_banner_element = document.getElementById('christmas_banner_metaobject_collection');
//             if (christmas_banner_element && !product.name.toLowerCase().includes("subscription")) {
//                 const christmasWrapper = document.createElement("div");
//                 christmasWrapper.innerHTML = christmas_banner_element.innerHTML;
//                 productCard.appendChild(christmasWrapper);
//             }
//             return(productCard);
//         } else if ((product.name.toLowerCase().includes('mid-collection') || product.name.toLowerCase().includes('mid collection')) && tagsProceed) {
//             const bannerUrl = product.customFields.find(field => field.key === 'custom-collection_mid_banner_url')?.value;
//             const wrapper_wrapper = document.createElement('div');
//             const wrapper = document.createElement('div');
//             wrapper.classList.add('group', 'relative', 'justify-center', 'bg-white', 'flex', 'flex-col', 'gap-0.5', "w-full", "h-full");
//             wrapper.setAttribute('data-handle', product.handle);
//             if (product.tags1.includes("feature-shoppable")) {
//                 wrapper.classList.add('mcb');
//             }
//             wrapper.classList.add('mid-collection-banner');
//             const padding = document.createElement('div');
//             padding.classList.add('w-full', 'pt-full');
//             let mobileUrl;
//             let desktopUrl;
//             for (image of prodImages) {
//                 if (image.toLowerCase().includes("desktop")) {
//                     desktopUrl = image;
//                 }
//                 if (image.toLowerCase().includes("mobile")) {
//                     mobileUrl = image;
//                 }
//             }
//             const mobileImg = document.createElement('img');
//             mobileImg.srcset = modifyUrlWithResolutions(mobileUrl);
//             mobileImg.setAttribute('src', mobileUrl);
//             mobileImg.classList.add('px-3', 'py-1', 'absolute', 'h-full', 'object-cover', "mobile-mcb");
//             mobileImg.style.left = "50%";
//             mobileImg.style.transform = "translateX(-50%)";
//             wrapper.appendChild(padding);
//             wrapper.appendChild(mobileImg);
//             const desktopImg = document.createElement('img');
//             desktopImg.srcset = modifyUrlWithResolutions(desktopUrl);
//             desktopImg.setAttribute('src', desktopUrl);
//             desktopImg.classList.add('px-3', 'py-1', 'absolute', 'h-full', 'object-cover', "desktop-mcb");
//             desktopImg.style.left = "50%";
//             desktopImg.style.transform = "translateX(-50%)";
//             wrapper.appendChild(padding);
//             wrapper.appendChild(desktopImg);
//             wrapper_wrapper.appendChild(wrapper);
//             target.append(wrapper_wrapper);


//             // element that will be wrapped in bannerUrl
//             if (bannerUrl) {
//                 topWrapper = document.createElement('a');
//                 topWrapper.setAttribute('href', bannerUrl.replace("https://www.myoddballs.com", "")); // Set the href to the bannerUrl

//                 // insert wrapper before el in the DOM tree
//                 wrapper.parentNode.insertBefore(topWrapper, wrapper);

//                 // move el into wrapper
//                 topWrapper.appendChild(wrapper);
//             }

//         }

//     } catch (error) {
//         console.error("Error adding: " + product.name);
//         console.error("Error: " + error);
//     }
// }
function generateProductLabel(data) {
    let available = data.available;
    const current_id = data.productId;
    const image_url = data.imageUrl;
    let prod_price = data.price;
    let comp_price = data.listPrice;
    const current_title = data.name;
    const tags = data.tags1;
  const toMinorUnits = (value) => {
        const parsed = parseFloat(value);
        return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
    };

    const compMinor = toMinorUnits(comp_price);
    const prodMinor = toMinorUnits(prod_price);
    const hasDiscount =
        compMinor !== null && prodMinor !== null && compMinor > prodMinor;
    const savingsMinor = hasDiscount ? compMinor - prodMinor : 0;

    let label_found = false;
    let savings = 0;
    const themeVersion = document.body.dataset.themeVersion;
    for (const label of labelList) {
        let proceed = false

        if (label.theme_version == themeVersion) {
            proceed = true;
        }

        if (label && proceed) {
            let labelMatch = label.tag_match;
            let bgColor = label.bg_color;
            let textColor = label.text_color;
            let labelText = label.text;
            let labelBorder = label.outline_color
            let countryUrl = document.body.getAttribute("country-url");
            const labelDisplay = label.show_hide_class

            if (!Array.isArray(tags)) continue;

            for (const tag of tags) {
                if (tag === labelMatch && !label_found) {
                    if (tag === "label-sale-percent-discount") {
                        if (hasDiscount) {
                            savings = Math.round((savingsMinor / compMinor) * 100);
                            if (savings < 1) continue;
                            label_found = true;
                            return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${savings}${translations.collections.percent_saving}</span>`;
                        }
                    } else if (tag === "label-sale-value-discount") {
                        if (hasDiscount) {
                            label_found = true;
                            const savingsFormatted = formatMoney(savingsMinor, GEBO.settings.shop_money_format);
                            return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">Save ${savingsFormatted}</span>`;
                        }
                    } else {
                        // default label handling
                        label_found = true;
                        return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${labelText}</span>`;
                    }
                }
            }
        }
    }
    return null;
}

function modifyUrlWithResolutions(url) { // used to return a source set with multiple resolutions
    var resolutions = [360, 420, 480, 640, 840, 1080, 1280, 1540, 1860, 1950];
    var parts = url.split('.');
    var fileName = parts.slice(0, -1).join('.');
    var fileExtension = parts[parts.length - 1];
    var modifiedUrls = [];

    for (var i = 0; i < resolutions.length; i++) {
        var resolution = resolutions[i];
        var modifiedUrl = fileName + "_" + (resolution / 4) + "x." + fileExtension + " " + resolution / 4 + "w";
        modifiedUrls.push(modifiedUrl);
    }

    var result = '';
    for (var j = 0; j < modifiedUrls.length; j++) {
        result += modifiedUrls[j];
        if (j !== modifiedUrls.length - 1) {
            result += ',';
        }

    }
    //return("")
    return result;
}
function getShopifyProductHandle(url) {
    if (!url) {
        return null;
    }

    try {
        // Remove any query parameters
        const urlWithoutParams = url.split('?')[0];
        // Split by '/' and get the last segment
        const segments = urlWithoutParams.split('/');
        const handle = segments[segments.length - 1];

         return handle;
    } catch (error) {
        //console.error('Error extracting handle:', error);
        return null;
    }
}
function titleLogic(product) {
    try {
        // Initial validation with detailed error
        if (!product) {
            return {
                cleanTitle: '',
                subTitle: '',
                onSale: false
            };
        }

        if (!product.name) {
            return {
                cleanTitle: '',
                subTitle: '',
                onSale: false
            };
        }

        let title = product.name;
        let cleanTitle = title;
        let subTitle = '';
        let onSale = false;

        try {
            // Safely check if product is on sale
            onSale = Boolean(product.compare_at_price > product.price);
        } catch (priceError) {
            onSale = false;
        }

        try {
            // Handle subscription products
            if (title.toLowerCase().includes("subscription") && !title.toLowerCase().includes("pre-paid") && false) {
                try {
                    let tags = Array.isArray(product.tags1) ? product.tags1 : [];
                    let temp = title.split("-");

                    for (let each of temp) {
                        if (each && each.toLowerCase().includes("sock")) {
                            cleanTitle = each.replace("& Sock", "& free sock");
                        }
                    }

                    if (tags.includes('subscription_classic')) {
                        subTitle = 'Plain Monthly Subscription';
                    } else if (tags.includes('subscription-patterned')) {
                        subTitle = "Patterned Monthly Subscription";
                    }
                } catch (subscriptionError) {
                    console.log('titleLogic: Error processing subscription:', subscriptionError);
                }
            }
            // Handle pre-paid products 
            else if (title.toLowerCase().includes("pre-paid")) {
                try {
                    let tags = Array.isArray(product.tags1) ? product.tags1 : [];

                    if (tags.includes('subscription_classic')) {
                        subTitle = '{{sub}} Plain Subscription';
                    } else if (tags.includes('subscription_adventurous')) {
                        subTitle = '{{sub}} Patterned Subscription';
                    }

                    if (title.includes('06 Month Pre-Paid: ')) {
                        try {
                            cleanTitle = subTitle.replace('{{sub}}', '6 month pre-paid ');
                            title = title.replace('06 Month Pre-Paid: ', '')
                                .replace('CLASSIC Subscription - ', '')
                                .replace('[G2]', '')
                                .replace(' monthly subscription', '')
                                .toLowerCase();
                        } catch (sixMonthError) {
                            console.log('titleLogic: Error processing 6-month pre-paid:', sixMonthError);
                        }
                    } else if (title.includes('12 Month Pre-Paid: ')) {
                        try {
                            cleanTitle = subTitle.replace('{{sub}}', '12 month pre-paid ');
                            title = title.replace('12 Month Pre-Paid: ', '')
                                .replace('CLASSIC Subscription - ', '')
                                .replace('[G2]', '')
                                .replace(' monthly subscription', '')
                                .toLowerCase();
                        } catch (twelveMonthError) {
                            console.log('titleLogic: Error processing 12-month pre-paid:', twelveMonthError);
                        }
                    }
                } catch (prePaidError) {
                    console.log('titleLogic: Error processing pre-paid subscription:', prePaidError);
                }
            }
            // Handle regular products
            else {
                try {
                    if (cleanTitle && cleanTitle.includes('-')) {
                        let cleanTitleArr = cleanTitle.split(' - ');
                        let cleanTitleFirst = cleanTitleArr[0] + ' - ';
                        subTitle = cleanTitle.replace(cleanTitleFirst, '');
                        cleanTitle = cleanTitleFirst.replace(' - ', '');
                    }
                } catch (regularProductError) {
                    console.log('titleLogic: Error processing regular product:', regularProductError);
                }
            }
        } catch (mainLogicError) {
            console.log('titleLogic: Error in main product type logic:', mainLogicError);
        }

        // Ensure clean return values
        return {
            cleanTitle: cleanTitle || '',
            subTitle: subTitle || '',
            onSale: Boolean(onSale)
        };

    } catch (globalError) {
        console.error('titleLogic: Critical error in title processing:', globalError);
        return {
            cleanTitle: product?.name || '',
            subTitle: '',
            onSale: false
        };
    }
}
let labelList;
get_labels();

function showNostoQuickBuyPopup(product, view = "qb") {

    const currency = document.body.getAttribute("currency");

    let countryUrl = document.body.getAttribute("country-url");
    countryUrl = (countryUrl == "/") ? "" : "";
    product.url = product.url.replace(/^https?:\/\/www\.myoddballs\.com/, "");


    // Construct view parameter with proper format
    const viewParam = `?view=${view}&currency=${currency}`;
    let url = countryUrl + product.url + viewParam;

    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            return response.text();
        })
        .then(data => {
            const loaders = document.querySelectorAll('.qb-loading');
            loaders.forEach(item => {
                item.classList.remove("qb-loading");
            })
            const qbLoc = document.getElementById("default-quick-buy-content");
            qbLoc.innerHTML = data;
            const qbPopup = document.getElementById("default-quick-buy-popup-content");
            const cohortACheck = document.getElementById("winter-banner-version-a")
            const cohortBCheck = document.getElementById("winter-sale-banner-version-b")
            const cohort = cohortACheck? "a" : cohortBCheck? "b" : "C" ;
            const winter10Banner = document.getElementById("qb-winter-10-banner");
      if(winter10Banner && cohort == "a"){
        winter10Banner.style.display="block";
        const triggerBanner = document.createElement("div")
        triggerBanner.dataset.dataCroFeatureLoaded = "winter-sale-banner"
        document.body.append(triggerBanner);
      }
            openPopup(qbPopup);
        })

}
document.addEventListener("click", ()=>{

    if (event.target.closest('.nosto-quick-add')) {

            // OLD SYSTEM: Use existing showCollectionQuickBuyPopup
            const wrapper = event.target.closest('.product-card');
            // Check if new system is already running
            if (wrapper.getAttribute('data-using-new-qb') === 'true') {
                return; // Don't run old system if new one is active
            }
            event.target.closest(".quick-add-wrapper").classList.add("qb-loading");
            const prod = JSON.parse(wrapper.querySelector('.prod-info').value);
            showNostoQuickBuyPopup(prod)
    }
    
})

async function get_labels() {
    const countryUrl = document.body.getAttribute("country-url");
    const url = countryUrl ? `https://www.myoddballs.com${countryUrl}/pages/perfect-pair?view=labels` : "https://www.myoddballs.com/pages/perfect-pair?view=labels";

    const data12 = await fetch(url);
    const html = await data12.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    let tempLabels = []
    const inputs = doc.querySelectorAll("input.tag");
    inputs.forEach(input => {
        tempLabels.push(JSON.parse(input.value));
    });
    labelList = tempLabels;
}
async function updateNonUKPrices(productId) {
    try {
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) {
            console.error(`Could not find card for product ID: ${productId}`);
            return;
        }

        const prodInfo = card.querySelector('.prod-info');

        const product = JSON.parse(prodInfo.value);

        const productHandle = getShopifyProductHandle(product.url);

        if (!productHandle) {
            return;
        }

       let currency = document.body.getAttribute("currency");
        const url = `/products/${productHandle}.js?country=${countryIso}` ;

        const response = await fetch(url);

        const shopifyProduct = await response.json();


        // Verify we have the correct product by comparing handles
        const shopifyHandle = shopifyProduct.handle;


        if (shopifyHandle !== productHandle) {
            return;
        }

        // Update price
        const priceElement = card.querySelector('.product-card__details__price');
        priceElement.setAttribute("price-updated", "true")
        if (is_sale) {
            const saleTag = product.tags1.find((tag) => {
                return tag.includes("lw-")
            })
            let saleAmount = Number(saleTag?.split("-").pop()) || 0;

            shopifyProduct.price = shopifyProduct.price * (1 - (saleAmount / 100));
        }
        if (priceElement) {
            let price = shopifyProduct.price;
            let comparePrice = shopifyProduct.compare_at_price;

            if (price % 100 !== 0) {
                price = parseFloat(price / 100).toFixed(2);
            } else {
                price = (price / 100);
            }

            const normalPrice = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price)

            let listPriceElement = '';
            if (comparePrice && comparePrice > shopifyProduct.price) {
                if (comparePrice % 1 !== 0) {
                    comparePrice = parseFloat(comparePrice / 100).toFixed(2);
                } else {
                    comparePrice = (comparePrice / 100);
                }
                listPriceElement = `<del nick class="ml-1 text-gray-400">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, comparePrice)}</del>`;
            } else {
                listPriceElement = `<del nick class="ml-1 text-gray-400 hidden">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price)}</del>`;
            }

            priceElement.innerHTML = `${normalPrice}${listPriceElement}`;
        }

        // Update title and product type
        const titleElement = card.querySelector('.product-card__details__title');
        const categoryElement = card.querySelector('.product-card__details__color');

        if (titleElement) {
            const titleLogicInput = {
                name: shopifyProduct.title,
                tags1: shopifyProduct.tags,
                compare_at_price: shopifyProduct.compare_at_price,
                price: shopifyProduct.price
            };

            const titleInfo = titleLogic(titleLogicInput);
         titleElement.textContent = titleInfo.cleanTitle;

            if (categoryElement && titleInfo.subTitle) {
                categoryElement.textContent = titleInfo.subTitle;
            }
        }

        // Update the stored product info
        const updatedProduct = {
            ...product,
            price: shopifyProduct.price / 100,
            listPrice: shopifyProduct.compare_at_price ? shopifyProduct.compare_at_price / 100 : shopifyProduct.price / 100,
            name: shopifyProduct.title,
            tags1: shopifyProduct.tags
        };
         prodInfo.value = JSON.stringify(updatedProduct);

      
    } catch (error) {
        console.error('Error updating product info:', error);
        console.error('Error stack:', error.stack);
    }
}

function getShopifyProductHandle(url) {
    if (!url) {
        return null;
    }

    try {
        // Remove any query parameters
        const urlWithoutParams = url.split('?')[0];
        // Split by '/' and get the last segment
        const segments = urlWithoutParams.split('/');
        const handle = segments[segments.length - 1];

        return handle;
    } catch (error) {
        //console.error('Error extracting handle:', error);
        return null;
    }
}
});